import React, { useState } from "react";
import { auth } from "../firebase"; // Import Firebase authentication instance
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { sendPasswordResetEmail } from "firebase/auth";
import RainbowBeard from "../images/rainbow-beard.jpg";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  // Function to send a password reset email
  const handlePasswordReset = (email) => {
    sendPasswordResetEmail(auth, email)
      .then(() => {
        // Password reset email sent successfully
        alert("Password reset email sent. Check your inbox.");
      })
      .catch((error) => {
        // Handle errors, e.g., if the email is not found
        console.error("Error sending password reset email: ", error);
        setError(error.message); // Set the error message state
      });
  };

  //   const handleSubmit = (e) => {
  //     e.preventDefault();
  //     const userEmail = e.target.email.value;
  //     handlePasswordReset(userEmail);
  //   };

  const handleSubmit = (e) => {
    e.preventDefault();
    handlePasswordReset(email); // Use the 'email' state variable
  };

  return (
    <Container className='mt-4'>
      <Row className='mt3 d-flex align-items-center'>
        <Col lg={6} className='whiteText mt-4 '>
          <h2>Reset Password</h2>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <Form>
            <Form.Group controlId='formBasicEmail'>
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type='email'
                placeholder='Enter email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Row>
              <Col>
                <Button className='btn btn-primary mb-4' onClick={handleSubmit}>
                  Send Reset Link
                </Button>
              </Col>
              <Col></Col>
            </Row>
          </Form>
        </Col>
        <Col lg={6} className='text-center'>
          <img src={RainbowBeard} alt='Artist Showcase' className='img-fluid' />
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;
